// config.js
const API_URL = "https://api2.resuranker.com";

const CONFIG = {
  API_URL,
  //API_URL: "http://localhost:5003",
  CREATE_CHECKOUT_SESSION: "https://createcheckoutsession-tunjghj3vq-uc.a.run.app/createCheckoutSession",
  CREATE_BILLINGPORTAL_SESSION: `${API_URL}/stripe/billing_portal`,
};

module.exports = CONFIG;
